import { render, staticRenderFns } from "./add_shoplist_user.vue?vue&type=template&id=50d0cb8c&scoped=true&"
import script from "./add_shoplist_user.vue?vue&type=script&lang=js&"
export * from "./add_shoplist_user.vue?vue&type=script&lang=js&"
import style0 from "./add_shoplist_user.vue?vue&type=style&index=0&id=50d0cb8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d0cb8c",
  null
  
)

export default component.exports